import { styled } from '@mui/material';

import { WidgetHubsReportContent } from '#features';

import { Widget } from '../base';

import type { WidgetConfigBase, WidgetProps } from '#features';

type Settings = Record<string, never>;
const config: WidgetConfigBase<Settings> = {};

const Root = styled(Widget)(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
  overflow: 'hidden',
}));

export const WidgetHubsReport = ({
  instance,
  showSettingsButton,
}: WidgetProps<Settings>) => (
  <Root
    config={config}
    showSettingsButton={showSettingsButton}
    instance={instance}
  >
    {settings => <WidgetHubsReportContent {...settings} />}
  </Root>
);
WidgetHubsReport.config = config;
